import { render } from "./TenantOverview.vue?vue&type=template&id=b3119920&scoped=true"
import script from "./TenantOverview.vue?vue&type=script&lang=js"
export * from "./TenantOverview.vue?vue&type=script&lang=js"

import "./TenantOverview.vue?vue&type=style&index=0&id=b3119920&scoped=true&lang=css"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3119920"]])

export default __exports__